import { get } from "./ApiService";

export const getRBSFilingsInfo = () => {
    let url = 'api/RBSFilings';
    return get(url).then(response =>
        response
    );
};